module.exports = __webpack_public_path__ + "static/media/image10.5a514301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mugen/image10.jpg
// module id = 1119
// module chunks = 0